import { ADDRESSINPUT_ROLE } from '@wix/wix-data-client-common-standalone'

import { type AddressInputData } from '../types'
import {
  assertAddressInputData,
  assertNonNullable,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const addComponentForAddressField: FieldComponentAdder = ({
  fieldKey,
  fieldName,
  page,
  templateComponentByVeloId,
  templateControllerConnectionsByVeloId,
}) =>
  addComponentForField({
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
    templateVeloId: 'addressFieldTemplate',
    componentAdjustments: {
      modifyComponent: component => {
        assertNonNullable(component.data)
        assertAddressInputData(component.data)
        const data: AddressInputData = { ...component.data, label: fieldName }
        return { ...component, data }
      },
      connectionConfigModifierByRole: {
        [ADDRESSINPUT_ROLE]: config =>
          setConnectionConfigPropertyField({
            config,
            propertyName: 'value',
            fieldKey,
          }),
      },
      veloId: `${fieldKey}Field`,
    },
  })
